import { Device, from, until } from '@helpers/media';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import TitleBlock from '@stories/Components/TitleBlock/TitleBlock';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  @media ${from(Device.TabletLarge)} {
    margin-top: 5rem;
    margin-bottom: 9rem;
  }
`;
const Inner = styled.div `
  display: flex;
  flex-direction: column;

  @media ${from(Device.DesktopLarge)} {
    flex-direction: row;
  }
`;
const ContentWrapper = styled.div `
  flex: 0 0 auto;

  @media ${until(Device.DesktopLarge)} {
    margin-bottom: 2rem;
    max-width: 90ch;
  }

  @media ${from(Device.DesktopLarge)} {
    margin-right: 3rem;
    max-width: 405px;
  }
`;
const Title = styled(TitleBlock) `
  margin-bottom: 2rem;
`;
const Content = styled.div `
  ${ParagraphStyles.contentStyles};

  p {
    ${ParagraphStyles.RegularStyles};
  }
`;
const SummaryWrapper = styled.div `
  flex: 1 1 auto;

  @media ${from(Device.DesktopLarge)} {
    align-self: flex-end;
  }
`;
const VehicleSummaryStyles = {
    Container,
    Content,
    ContentWrapper,
    Inner,
    SummaryWrapper,
    Title,
};
export default VehicleSummaryStyles;
